import React from "react"
import FieldMultiselect from "../multiselect";


export type FieldMultiselectEditableProps = {
    field           : FieldMultiselect
    model           : any
    onChange?       : onChangeCallback
    className?      : string,
    options?        : any
    configOptions?  : any
};

export default class FieldMultiselect_InlineEditable extends React.Component<FieldMultiselectEditableProps, any> {

    public previousOptions  : any

    constructor(props:FieldMultiselectEditableProps) {
        super(props);

        const value = this.props.model[this.props.field.fieldId]

        this.state = {
            currentOptions: value,
            showPopover: false,
        }
    }

    showPopover = () => {
        if (!this.state.showPopover) this.setState({showPopover: true})
    }
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    onOptionClick = (option:any) => {
        let currentOptions = this.state.currentOptions ? this.state.currentOptions.slice() : [];
        this.previousOptions = currentOptions;

        if (!!option.isAllValuesOption) {
            // all values option click
            currentOptions = null;
        } else {
            currentOptions = gd.utils.toggleArrayValue(currentOptions, option.value);
        }

        // clear outdated values (removed from options) if any from currentOptions
        let options = this.props.field.getOptions()?.slice()
        if (options) {
            const availableValues = _.map(options, option=>option.value)
            currentOptions = _.intersection(currentOptions, availableValues)
        }

        this.setState({
            currentOptions: currentOptions
        }, () => {
            if (this.props.onChange) this.props.onChange(currentOptions);
            // if (this.props.onChange) this.props.onChange(currentOptions, this.onCancelChange);
        });
    }

    onCancelChange = () => {
        this.setState({
            currentOptions: this.previousOptions
        });
    }

    render() {
        const {field} = this.props;

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        });

        const selectedOptions = this.props.field._getOptions(this.state.currentOptions);

        // need check value because of none
        if (!!selectedOptions && selectedOptions.length > 0) {
            return (
                <field.components.InlineValueNotEmpty className     = {classes}
                                                      field         = {field}
                                                      options       = {selectedOptions}
                                                      configOptions = {this.props.configOptions}
                                                      onClick       = {this.showPopover}
                                                      onDelete      = {this.onOptionClick}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                </field.components.InlineValueNotEmpty>
            );
        }

        // Empty - no value
        return (
            <field.components.InlineValueEmpty className        = {classes}
                                               field            = {this.props.field}
                                               options          = {selectedOptions}
                                               configOptions    = {this.props.configOptions}
                                               onClick          = {this.showPopover}>
                {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
            </field.components.InlineValueEmpty>
        );

    }
}